import { styled } from '@mui/material/styles';

export const TaskItemWrapper = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  backgroundColor: 'var(--color-element)',
  marginBottom: '16px',
  borderRadius: '16px',
  padding: '16px 12px',
}));

export const TaskItemContainer = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center',
}));

export const IconWrapper = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: '6px',
  width: '40px',
  height: '40px',
  boxSizing: 'border-box',
  padding: '2px',
  '& svg': {
    height: '30px',
    width: '30px',
    '& [stroke]': {
      stroke: 'var(--color-accent)',
    },
    '& [fill]': {
      fill: 'var(--color-accent)',
    },
  },
}));

export const TaskItemContent = styled('div')(() => ({
  marginLeft: '16px',
}));

export const TaskItemTitle = styled('h4')(() => ({
  margin: 0,
  fontWeight: 600,
  lineHeight: '18px',
}));

export const TaskItemText = styled('div')(() => ({
  margin: '6px 0 0 0',
  fontWeight: 500,
  fontSize: '12px',
  lineHeight: '16px',
  color: 'var(--color-type-secondary)',
}));